import { Component, OnInit, ViewChild, Input, TemplateRef } from '@angular/core';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from 'ng-gallery' //from "@ngx-gallery/core";
//import { Lightbox } from "@ngx-gallery/lightbox";
import { Lightbox } from 'ng-gallery/lightbox';
import { AveriasService } from '../servicios/averias.service';
import { detallesDiscrepancia, solucionarDiscrepanciaDTO } from '../entidades/entidades.component';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { NbSelectModule } from '@nebular/theme';
import { NbOptionModule } from '@nebular/theme';
@Component({
    selector: 'app-discrepancias-activas',
    templateUrl: './discrepanciaActivas.component.html',
    styleUrls: ['./discrepanciasActivas.css'],
    standalone: true,
    imports: [CommonModule,FormsModule, DropdownModule, NbIconModule,SpinnerComponent,NbCardModule,
      NbSelectModule,NbOptionModule
    ],
})
export class DiscrepanciasActivasComponent implements OnInit {
  //#region  Variables
  showSpinnerFotos = true;
  imageData = fotosDefault;
  idFoto = 0;
  showLoad = false;
  indexFoto = 0;
  items: GalleryItem[];
  areaComponente = [];
  areaComponenteSeleccionada;
  tipoAveria = [];
  tipoAveriaSeleccionada;
  severidad = [];
  SeveridadSeleccionada;
  zonaCuadranteDetalle = [];
  zonaCuadranteDetalleSeleccionada;
  responsables = [];
  clasificacion = [];
  clasificacionSeleccionada;
  responsablesSeleccionada;
  idCliente;
  cargado = false;
  editar = false;
  cargo = false;
  habilitarGuardarCambios = false;
  deshabilitarSolucionar = false;
  durationInSeconds = 5;
  showSpinnerGuardar: boolean = false;
  comentarioAveria = '';
  myConfig = {
    btnContainerClass: '',            // The CSS class(es) to be applied to the button container
    btnClass: 'default',              // The CSS class(es) that will be applied to the buttons e.g. default is needed for FontAwesome icons, while not needed for Material Icons
    btnSubClass: 'material-icons',    // The CSS class(es) that will be applied to span elements inside material buttons (a Elements)
    zoomFactor: 0.1,                  // The amount that the scale will be increased by
    containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
    wheelZoom: true,                  // If true, the mouse wheel can be used to zoom in
    allowFullscreen: false,            // If true, the fullscreen button will be shown, allowing the user to enter fullscreen mode
    allowKeyboardNavigation: true,    // If true, the left / right arrow keys can be used for navigation
    btnShow: {                        // Control which icons should be visible                
      zoomIn: false,
      zoomOut: false,
      rotateClockwise: false,
      rotateCounterClockwise: false,
      next: false,
      prev: false,
      reset: false
    },
    btnIcons: {                       // The icon classes that will apply to the buttons. By default, font-awesome is used.
      zoomIn: {
        classes: 'fa fa-plus',        // this property will be used for FontAwesome and other libraries to set the icons via the classes - choose one: classes or text
        text: 'zoom_in'               // this property will be used for Material-Icons and similar libraries to set the icons via the text
      },
      zoomOut: {
        classes: 'fa fa-minus',
        text: 'zoom_out'
      },
      rotateClockwise: {
        classes: 'fa fa-repeat',
        text: 'rotate_right'
      },
      rotateCounterClockwise: {
        classes: 'fa fa-undo',
        text: 'rotate_left'
      },
      next: {
        classes: 'fa fa-arrow-right',
        text: 'arrow_right'
      },
      prev: {
        classes: 'fa fa-arrow-left',
        text: 'arrow_left'
      },
      fullscreen: {
        classes: 'fa fa-arrows-alt',
        text: 'fullscreen'
      },
      reset: {
        classes: 'fa fa-undo',
        text: 'restore'
      }
    }
  };
  //#endregion
  isComentarioEdicion = null

  //#region Input/Output
  @Input() public data: detallesDiscrepancia;
  @Input() public fotosResponse;
  @ViewChild("itemTemplate", { static: true }) itemTemplate: TemplateRef<any>;
  public solucionada: boolean = false;
  //#endregion

  constructor(public gallery: Gallery,
    public lightbox: Lightbox,
    private AveriasService: AveriasService,
    public usersRol: PerfilesUsuarioService,
    private _snackBar: MatSnackBar,
    private dialogService: NbDialogService,
    protected dialogRef: NbDialogRef<DiscrepanciasActivasComponent>
  ) { }

  ngOnInit(): void {
    this.showSpinnerFotos = true;
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.comentarioAveria = this.data.comentarioModificacion ? this.data.comentarioModificacion : '';
    this.mapeoFotos();

    this.AveriasService.getTipo(this.idCliente).subscribe(data => {
      this.insertarTipo(data);
    })
    this.AveriasService.getSeveridad(this.idCliente).subscribe(data => {
      this.insertarSeveridad(data);
    })
    this.AveriasService.getZonaCuadranteDetallePorAreaComponente(this.data.idAreaComponente).subscribe(data => {
      this.insertarZonaCuadranteDetalle(data);
    })
    this.AveriasService.getOperadoresPorCliente(this.idCliente).subscribe(data => {
      this.insertarResponsables(data);
    })
    this.AveriasService.getClasificacion(this.idCliente).subscribe(data => {
      this.insertarClasificacion(data);
    })
  }
  ngAfterViewInit() {
  }
  mapeoFotos() {
    if (this.data.listaFotosAverias.length > 0) {
      this.imageData = [];
      this.data.listaFotosAverias.forEach(element => {
        this.imageData.push({
          src: 'data:image/png;base64,' + element.foto,
          thumb: 'data:image/png;base64,' + element.foto
        })
      });
    }

    this.items = this.imageData.map(item => {
      return {
        type: "imageViewer",
        data: {
          src: item.src,
          thumb: item.thumb
        }
      };
    });
    // Get a lightbox gallery ref
    const lightboxRef = this.gallery.ref("lightbox");

    // Add custom gallery config to the lightbox (optional)
    lightboxRef.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top,
      itemTemplate: this.itemTemplate,
      //gestures: false
    });

    // Load items into the lightbox gallery ref
    lightboxRef.load(this.items);
  }


  
//GALLERYA MANUAL ****************************************************

//  selectedImage = this.imageData[0].src;

    selectedIndex = 0;
    get selectedImageData() {
      return this.imageData[this.selectedIndex].src;
    }

    lightboxOpen = false;
    zoom = 1;
    readonly zoomStep = 0.1;
    readonly zoomMin = 1;
    readonly zoomMax = 3;

    // Arrastre
    isDragging = false;
    startX = 0;
    startY = 0;
    currentX = 0;
    currentY = 0;

    selectImageByIndex(index: number) {
      this.selectedIndex = index;
      this.resetZoomAndPosition();
    }

    selectImage(src: string) {
      const index = this.imageData.findIndex(i => i.src === src);
      if (index !== -1) this.selectImageByIndex(index);
    }

    openLightbox() {
      this.lightboxOpen = true;
      this.resetZoomAndPosition();
    }

    closeLightbox() {
      this.lightboxOpen = false;
      this.resetZoomAndPosition();
    }

    resetZoomAndPosition() {
      this.zoom = 1;
      this.currentX = 0;
      this.currentY = 0;
    }

    onWheel(event: WheelEvent) {
      event.preventDefault();

      if (event.deltaY < 0) {
        this.zoom = Math.min(this.zoom + this.zoomStep, this.zoomMax);
      } else {
        this.zoom = Math.max(this.zoom - this.zoomStep, this.zoomMin);
      }

      if (this.zoom <= 1) {
        this.currentX = 0;
        this.currentY = 0;
      }
    }

    onMouseDown(event: MouseEvent) {
      if (this.zoom <= 1) return;
      this.isDragging = true;
      this.startX = event.clientX - this.currentX;
      this.startY = event.clientY - this.currentY;
    }

    onMouseMove(event: MouseEvent) {
      if (!this.isDragging) return;
      this.currentX = event.clientX - this.startX;
      this.currentY = event.clientY - this.startY;
      // Limitar movimiento si quieres aquí
    }

    onMouseUp() {
      this.isDragging = false;
    }

    onMouseLeave() {
      this.isDragging = false;
    }

    // Navegación
    prevImage() {
      if (this.selectedIndex > 0) {
        this.selectImageByIndex(this.selectedIndex - 1);
      }
    }

    nextImage() {
      if (this.selectedIndex < this.imageData.length -1) {
        this.selectImageByIndex(this.selectedIndex + 1);
      }
    }

  // END GALLERYA MANUAL ****************************************************




  //Área
  insertarArea(armarArea) {
    armarArea.content.forEach(element => {
      this.areaComponente.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.areaComponenteSeleccionada = this.data.idAreaComponente;

  };
  //Avería
  insertarTipo(armarTipo) {
    armarTipo.content.forEach(element => {
      this.tipoAveria.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.tipoAveriaSeleccionada = this.data.idTipoAveria;
    this.cargo = true;
    this.showSpinnerFotos = false;
  };
  //Severidad
  insertarSeveridad(armarSeveridad) {
    armarSeveridad.content.forEach(element => {
      this.severidad.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.SeveridadSeleccionada = this.data.idSeveridad;
  };
  insertarZonaCuadranteDetalle(armarZonaCuadranteDetalle) {
    armarZonaCuadranteDetalle.forEach(element => {
      this.zonaCuadranteDetalle.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.zonaCuadranteDetalleSeleccionada = this.data.idZonaCuadranteDetalle;
  };
  insertarResponsables(armarResponsables) {
    armarResponsables.forEach(element => {
      this.responsables.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.responsablesSeleccionada = this.data.idResponsable;
  };
  insertarClasificacion(armarClasificacion) {
    armarClasificacion.content.forEach(element => {
      this.clasificacion.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.clasificacionSeleccionada = this.data.idClasificacion;
  };
  //
  habilitarEdicion() {
    this.editar = true;
    this.habilitarGuardarCambios = true;
    this.deshabilitarSolucionar = true;
  }
  deshabilitarEdicion() {
    this.editar = false;
    this.habilitarGuardarCambios = false;
    this.deshabilitarSolucionar = false;
    this.isComentarioEdicion = null;
  }
  styleTextArea() {
    return { 'width': '90%', 'border': this.isComentarioEdicion === false ? '1px solid red' : '' }
  }
  saveEdicionYSolucionar() {
    // Guardamos y modificamos la averia original
    if (this.comentarioAveria === '') {
      this.isComentarioEdicion = false
      return
    } else {
      this.isComentarioEdicion = true
    }
    let guardar = [
      {
        idDiscrepancia: this.data.idDiscrepancia,
        idVinAveria: this.data.idVinAveria,
        idZonaCuadranteDetalle: this.zonaCuadranteDetalleSeleccionada,
        idTipoAveria: this.tipoAveriaSeleccionada,
        idSeveridad: this.SeveridadSeleccionada,
        idResponsable: this.responsablesSeleccionada,
        idClasificacion: this.clasificacionSeleccionada,
        comentarioModificacion: this.comentarioAveria,
      }
    ];
    this.showSpinnerGuardar = true;
    this.AveriasService.editDetalleAveria(guardar).subscribe(data => {
      if (data.status == 200) {
        alert("Registro modificado y solucionado correctamente.");
        // SE COMENTÓ EL 10/06/2021 this.SolucionarDiscrepancias();
        this.deshabilitarSolucionar = false;
        this.habilitarGuardarCambios = false;
        this.editar = false;
        this.dialogRef.close(true);
      }
      else {
        this.dialogRef.close(false);
        alert("Ocurrio un error al modificar los datos.");
      }
      this.showSpinnerGuardar = false;
    }, error => {
      this.dialogRef.close(false);
      alert("Ocurrio un error al modificar los datos.");
    })
  }
  // Solucionamos y guardamos la averia original
  SolucionarDiscrepancias(res) {
    // var objSolucion: solucionarDiscrepanciaDTO;
    var objSolucion;
    this.showSpinnerGuardar = true;
    objSolucion = {
      idDiscrepancia: this.data.idDiscrepancia,
      idVinAveria: this.data.idVinAveria,
      idTipoAveria: this.tipoAveriaSeleccionada,
      idSeveridad: this.SeveridadSeleccionada,
      idResponsable: this.responsablesSeleccionada,
      idClasificacion: this.clasificacionSeleccionada,
      comentarioSolucion: res ? res : null
    }
    this.AveriasService.SolucionarDiscrepancias(objSolucion).subscribe(data => {
      if (data.status == 200) {
        // this.openSnackBar("Discrepancia solucionada correctamente");
        alert("Discrepancia solucionada correctamente.");
        this.solucionada = true;
        this.dialogRef.close(true);
      }
      else {
        // this.openSnackBar("Ocurrio un error al soluciona la discrepancia");
        alert("Ocurrio un error al soluciona la discrepancia.");
      }
      this.showSpinnerGuardar = false;
    });
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  close() {
    this.dialogRef.close(false);
  }
  // Abre popup de confirmacion al solucionar la original
  open() {
    this.dialogService.open(ConfirmPopupComponent)
      .onClose.subscribe(res => {
        if (res) {
          this.SolucionarDiscrepancias(res)
        }
      });
  }
}
var fotosDefault = [
  {
    src: "assets/img/no_disponible.jpg",
    thumb: "assets/img/no_disponible.jpg"
  }
];


